import { Controller } from "@hotwired/stimulus"

// Toggles a membership plan between Repeats and One time (doesn't renew).
// One time charges once, hides "How many payments", relabels the interval
// as "Access lasts", and forces visit counts to Top up.
export default class extends Controller {
  static targets = [
    "mode",
    "iterationsPanel",
    "iterationsField",
    "billsLabel",
    "accessLabel",
    "intervalHelp",
    "oneTimeHelp",
    "monthlyChoice",
    "monthlyMode",
    "topUpMode"
  ]

  static values = { locked: Boolean }

  connect() {
    this.savedIterations = this.hasIterationsFieldTarget ? this.iterationsFieldTarget.value : ""
    this.sync()
  }

  modeChanged() {
    this.sync()
  }

  sync() {
    if (this.lockedValue) return

    const oneTime = this.selectedMode === "one_time"
    this.iterationsPanelTarget?.classList.toggle("hidden", oneTime)
    this.billsLabelTarget?.classList.toggle("hidden", oneTime)
    this.accessLabelTarget?.classList.toggle("hidden", !oneTime)
    this.intervalHelpTarget?.classList.toggle("hidden", oneTime)
    this.oneTimeHelpTarget?.classList.toggle("hidden", !oneTime)
    this.monthlyChoiceTarget?.classList.toggle("hidden", oneTime)

    if (this.hasIterationsFieldTarget) {
      this.iterationsFieldTarget.disabled = oneTime
      if (oneTime) {
        if (this.iterationsFieldTarget.value !== "1") this.savedIterations = this.iterationsFieldTarget.value
        this.iterationsFieldTarget.value = ""
      } else if (this.savedIterations && this.savedIterations !== "1") {
        this.iterationsFieldTarget.value = this.savedIterations
      }
    }

    if (oneTime && this.hasTopUpModeTarget) {
      this.topUpModeTarget.checked = true
      this.topUpModeTarget.disabled = false
      if (this.hasMonthlyModeTarget) this.monthlyModeTarget.disabled = true
      this.topUpModeTarget.dispatchEvent(new Event("change", { bubbles: true }))
    } else if (this.hasMonthlyModeTarget) {
      this.monthlyModeTarget.disabled = false
    }
  }

  get selectedMode() {
    const checked = this.modeTargets.find((el) => el.checked)
    return checked?.value || "repeats"
  }
}
